import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getActivityConfigurations = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/ActivityConfiguration/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching activity configurations:", error);
    throw error;
  }
};

export const saveActivityConfiguration = async (configuration) => {
  const response = await axios.post(`${BASE_URL}/api/ActivityConfiguration/save`, configuration, {
    headers: getAuthHeader(),
  });
  return response.data;
};
